export const RomajiCheck = {
  validate (value) {
    return /^[a-zA-Z0-9]+$/.test(value.trim())
  },
  getMessage (field) {
    return `「${field}」は英数字で入力してください。`
  }
}

export const EmailCheck = {
  validate (value) {
    return /([0-9a-zA-Z]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)
  },
  getMessage (field) {
    return `メールは正しくありません。フォーマットを確認してください。`
  }
}

export const NumberCheckLength = {
  validate (value, [min]) {
    return value.toString().replace(/[^\d]/g, '').length <= min
  },
  getMessage (field, [min]) {
    return `「${field}」は${min}文字以内を入力してください。`
  }
}

export const JustNumberCheckLength = {
  validate (value, [min]) {
    return value.toString().replace(/[^\d]/g, '').length === parseInt(min, 10)
  },
  getMessage (field, [min]) {
    return `「${field}」は${min}桁で入力してください。`
  }
}

export const MoneyMin = {
  validate (value, min) {
    return parseInt(value) >= min
  },
  getMessage (field, [min]) {
    return `「${field}」は${min}以上でなければなりません。`
  }
}

export const BankAccountOnlyNumber = {
  validate (value) {
    // eslint-disable-next-line no-unneeded-ternary
    return (value.match(/^[0-9]+$/)) ? true : false
  },
  getMessage (field) {
    return `「${field}」は半角数字で入力してください。`
  }
}

export const BankAccountOnlyName = {
  validate (value) {
    // eslint-disable-next-line no-unneeded-ternary
    return (value.match(/^[( |　|-||ｰ|ー|−)a-zA-Z0-9ｦｧｨｩｪｫｬｭｮｯｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜﾝｶﾞｷﾞｸﾞｹﾞｺﾞｻﾞｼﾞｽﾞｾﾞｿﾞﾀﾞﾁﾞﾂﾞﾃﾞﾄﾞﾊﾞﾋﾞﾌﾞﾍﾞﾎﾞﾊﾟﾋﾟﾌﾟﾍﾟﾎﾟｳﾞ()ＡＢＣＤＥＦＧＨＩＪＫＬＭＮＯＰＱＲＳＴＵＶＷＸＹＺａｂｃｄｅｆｇｈｉｊｋｌｍｎｏｐｑｒｓｔｕｖｗｘｙｚ０１２３４５６７８９あいうえおかがきぎくぐけげこごさざしじすずせぜそぞただちぢつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもやゆよらりるれろゎわをんァアィイゥウェエォオカガキギクグケゲコゴサザシジスズセゼソゾタダチヂッツヅテデトドナニヌネノハバパヒビピフブプヘベペホボポマミムメモャヤュユョヨラリルレロヮワヲンヴヵヶ（）．－゛゜]+$/)) ? true : false
  },
  getMessage (field) {
    return `「${field}」は入力可能な文字種で入力してください。`
  }
}



// WEBPACK FOOTER //
// ./src/validation/custom-rules.js